'use strict';

window.addEventListener('DOMContentLoaded', function() {
	document.querySelectorAll('.safemail').forEach( item => {
		item.addEventListener('click', e => {
			e.preventDefault();
			window.location.href = 'mailto:' + e.currentTarget.dataset.name + '@' + e.currentTarget.dataset.domaintld;
			return false;
		});
	});
});
